import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _state, _mutations;

import types from "./types";
import getters from "./getters";
import store from "@/store"; // 全局变量

var state = (_state = {
  userToken: window.sessionStorage.userToken || null,
  accessToken: window.sessionStorage.accessToken || null,
  userData: JSON.parse(window.sessionStorage.userData || "{}"),
  bpmnSid: window.sessionStorage.bpmnSid || "",
  theme: "",
  chooseDept: null,
  //部门树数据
  chooseDataScopeDept: null,
  //管辖部门树数据
  status: "add",
  userMenus: [],
  newUserMenus: [],
  defaultCheckedArray: [],
  studentChooseTree: null,
  //学生树数据
  personChargeData: [],
  hierarchyTree: null,
  //树数据
  dialogTitle: "新增节点",
  formData: {
    id: "",
    hieName: "",
    target: "",
    hasChildren: ""
  },
  dialogVisible: false,
  labelWidth: "100px",
  radioArray: [{
    value: 0,
    text: "否"
  }, {
    value: 1,
    text: "是"
  }],
  lableArray: {
    id: "ID:",
    hieName: "名称:",
    target: "目标:",
    hasChildren: "是否有子元素:"
  },
  access_token: "",
  //token
  userInfo: {},
  //个人信息
  permissions: {},
  actives: null,
  activeTags: null,
  menuUrl: null,
  checkedArray: []
}, _defineProperty(_state, "userMenus", []), _defineProperty(_state, "roleTypeData", [{
  value: 0,
  label: "教师"
}, {
  value: 1,
  label: "学生"
}]), _defineProperty(_state, "userPermissionTypeDialog", {
  promptType: "",
  promptTittle: "新增",
  currentRowData: null,
  currentRoleId: ""
}), _defineProperty(_state, "permissionDialog", false), _defineProperty(_state, "roleFormDialog", {
  status: "",
  dialogTittle: "新增",
  currentRowData: null
}), _defineProperty(_state, "roleFormData", {
  roleId: "",
  roleName: "",
  roleCode: "",
  roleType: "",
  roleDesc: "",
  defaultPage: "",
  defaultPageId: ""
}), _defineProperty(_state, "defaultPageDialog", false), _defineProperty(_state, "userTypes", [{
  label: "学生",
  value: "0"
}, {
  label: "教师",
  value: "1"
}, {
  label: "教职工",
  value: "2"
}]), _defineProperty(_state, "checkedItemArray", []), _defineProperty(_state, "previewFileData", {
  data: null,
  state: false
}), _defineProperty(_state, "tabsData", []), _defineProperty(_state, "moduleList", []), _defineProperty(_state, "unReadMsgCount", 0), _state); // 内部方法

var mutations = (_mutations = {}, _defineProperty(_mutations, types.SET_USER_DTOKEN, function (state, value) {
  state.userToken = value;
}), _defineProperty(_mutations, types.SET_ACCESS_DTOKEN, function (state, value) {
  state.accessToken = value;
}), _defineProperty(_mutations, types.SET_USER_DATA, function (state, value) {
  state.userData = value;
  window.sessionStorage.userData = JSON.stringify(value);
  return new Promise(function (resolve) {
    resolve();
  });
}), _defineProperty(_mutations, types.LOGIN_OUT, function (state) {
  // window.sessionStorage.clear()
  localStorage.removeItem("userData");
  localStorage.removeItem("token");
  sessionStorage.removeItem("vuex");
  sessionStorage.removeItem("nz_access_token");
  sessionStorage.removeItem("setConfig");
  sessionStorage.removeItem("userData");
  document.cookie = null;
  state.userToken = null;
  state.accessToken = null;
  state.userData = null;
  return new Promise(function (resolve) {
    resolve();
  });
}), _defineProperty(_mutations, types.CHANGE_THEME, function (state, value) {
  state.theme = value;
}), _defineProperty(_mutations, "setBpmnSid", function setBpmnSid(state, value) {
  state.bpmnSid = value;
  window.sessionStorage.loginBpmnTime = "" + Date.now();
  window.sessionStorage.bpmnSid = value;
}), _defineProperty(_mutations, "setStatus", function setStatus(state, params) {
  state.status = params;
}), _defineProperty(_mutations, "setTabsData", function setTabsData(state, params) {
  state.tabsData = params;
}), _defineProperty(_mutations, "setRoleFormDialogStatus", function setRoleFormDialogStatus(state, params) {
  // 原setStatus,内诊移植过来重名了
  state.roleFormDialog.status = params;
}), _defineProperty(_mutations, "setFormTitle", function setFormTitle(state) {
  if (state.status === "add") {
    state.dialogTitle = "新增节点";
  } else if (state.status === "edit") {
    state.dialogTitle = "编辑节点";
  }
}), _defineProperty(_mutations, "setFormData", function setFormData(state, params) {
  var keys = Object.keys(state.formData);
  Object.keys(params.originData).forEach(function (key) {
    if (keys.includes(key)) {
      state.formData[key] = params.originData[key];
    }
  });
}), _defineProperty(_mutations, "setDialog", function setDialog(state) {
  state.dialogVisible = !state.dialogVisible;
}), _defineProperty(_mutations, "clearForm", function clearForm(state) {
  if (state.status === "add") {
    Object.keys(state.formData).forEach(function (key) {
      state.formData[key] = "";
    });
  }
}), _defineProperty(_mutations, "SET_ACCESS_TOKEN", function SET_ACCESS_TOKEN(state, access_token) {
  state.access_token = access_token;
}), _defineProperty(_mutations, "SET_LOG_MSG", function SET_LOG_MSG(state, data) {
  state.userInfo = data;
}), _defineProperty(_mutations, "SET_PERMISSIONS", function SET_PERMISSIONS(state, permissions) {
  var list = {};

  for (var i = 0; i < permissions.length; i++) {
    list[permissions[i]] = true;
  }

  state.permissions = list;
}), _defineProperty(_mutations, "SET_CHOOSE_DEPT", function SET_CHOOSE_DEPT(state, deptData) {
  //部门tree数据
  state.chooseDept = deptData;
}), _defineProperty(_mutations, "SET_STUDENT_TREE", function SET_STUDENT_TREE(state, deptData) {
  // 学生tree数据
  var a = function a(data) {
    data.forEach(function (e) {
      e.expandId = e.id;

      if (e.children.length > 0) {
        a(e.children);
      }
    });
  };

  a(deptData);
  state.studentChooseTree = deptData;
}), _defineProperty(_mutations, "SET_NEW_MENU", function SET_NEW_MENU(state, menu) {
  state.newUserMenus = menu;
}), _defineProperty(_mutations, "SET_MENU", function SET_MENU(state, menu) {
  state.userMenus = menu;
}), _defineProperty(_mutations, "SET_ACTIVES", function SET_ACTIVES(state, actives) {
  state.actives = actives;
}), _defineProperty(_mutations, "SET_ACTIVE_TAG", function SET_ACTIVE_TAG(state, data) {
  state.activeTags = data;
}), _defineProperty(_mutations, "SET_MENU_URL", function SET_MENU_URL(state, menuUrl) {
  state.menuUrl = menuUrl;
}), _defineProperty(_mutations, "clearCheckedData", function clearCheckedData(state) {
  state.checkedArrayObj = [];
}), _defineProperty(_mutations, "clearChecked", function clearChecked(state) {
  state.checkedArray = [];
}), _defineProperty(_mutations, "clearDefaultChecked", function clearDefaultChecked(state) {
  state.defaultCheckedArray = [];
  state.checkedArray = [];
}), _defineProperty(_mutations, "setDialogVisible", function setDialogVisible(state, params) {
  state.dialogVisible = params;
}), _defineProperty(_mutations, "setPermissionDialog", function setPermissionDialog(state, params) {
  state.permissionDialog = params;
}), _defineProperty(_mutations, "setCurrentRowData", function setCurrentRowData(state, params) {
  state.roleFormDialog.currentRowData = params;
}), _defineProperty(_mutations, "setRoleFormData", function setRoleFormData(state, params) {
  var keys = Object.keys(state.roleFormData);
  Object.keys(params).forEach(function (key) {
    if (key == "defaultPage") {
      state.roleFormData["defaultPageId"] = Number(params["defaultPage"]);
      store.getters.userMenus.forEach(function (item, index) {
        if (item.children.length > 0) {
          item.children.forEach(function (value, key) {
            if (value.id == state.roleFormData.defaultPageId) {
              state.roleFormData["defaultPage"] = value.name;
              return;
            }
          });
        }
      });
    } else {
      if (keys.includes(key) && !["defaultPageId", "defaultPage"].includes(key)) {
        state.roleFormData[key] = params[key];
      }
    }
  });
}), _defineProperty(_mutations, "setDialogTittle", function setDialogTittle(state, params) {
  state.roleFormDialog.dialogTittle = params;
}), _defineProperty(_mutations, "setPromptType", function setPromptType(state, params) {
  state.userPermissionTypeDialog.promptType = params;
}), _defineProperty(_mutations, "setCurrentRoleId", function setCurrentRoleId(state, params) {
  state.userPermissionTypeDialog.currentRoleId = params;
}), _defineProperty(_mutations, "setPromptTittle", function setPromptTittle(state, params) {
  state.userPermissionTypeDialog.promptTittle = params;
}), _defineProperty(_mutations, "setAddRoleFormData", function setAddRoleFormData(state, param) {
  // state.roleFormData.roleType=param;
  state.roleFormData = {
    roleId: "",
    roleName: "",
    roleCode: "",
    roleType: param,
    roleDesc: "",
    defaultPage: "",
    defaultPageId: ""
  };
}), _defineProperty(_mutations, "setDefaultPageDialog", function setDefaultPageDialog(state, params) {
  state.defaultPageDialog = params;
}), _defineProperty(_mutations, "setDefaultPage", function setDefaultPage(state, params) {
  var name = params.name,
      id = params.id;
  state.roleFormData.defaultPageId = id;
  state.roleFormData.defaultPage = name;
  state.defaultPageDialog = false;
}), _defineProperty(_mutations, "setDefaultChecked", function setDefaultChecked(state, params) {
  var newArr = params.map(function (item) {
    return Number(item); // return item;
  });
  state.defaultCheckedArray = newArr;
  state.checkedArray = newArr;
}), _defineProperty(_mutations, "clearCheckedItem", function clearCheckedItem(state) {
  state.checkedItemArray = [];
}), _defineProperty(_mutations, "deleteCheckedItem", function deleteCheckedItem(state, params) {
  var index = state.checkedItemArray.findIndex(function (e) {
    return e.id == params.id;
  });
  state.checkedItemArray.splice(index, 1);
}), _defineProperty(_mutations, "setPreviewFileData", function setPreviewFileData(state, params) {
  state.previewFileData = params;
}), _defineProperty(_mutations, "setModuleList", function setModuleList(state, data) {
  state.moduleList = data;
}), _defineProperty(_mutations, "setUnreadMsgCount", function setUnreadMsgCount(state, unreadCount) {
  state.unReadMsgCount = unreadCount;
}), _mutations);
export default {
  state: state,
  mutations: mutations,
  getters: getters
};